import { useState } from "react";
import * as Icons from "lucide-react";
import { X } from "lucide-react";
import { CategoryPicker } from "@/components/add/CategoryPicker";
import { useI18n } from "@/context/I18nContext";

export function CategoryChip({ value, onChange, cats, tid }) {
  const { lang } = useI18n();
  const [open, setOpen] = useState(false);
  const cur = cats.find((c) => c.id === value) || cats[0];
  if (!cur) return null;
  const Icon = Icons[cur.icon] || Icons.Circle;
  return (
    <>
      <button
        type="button"
        data-testid={tid}
        onClick={() => setOpen(true)}
        className="w-full flex items-center gap-2 px-3 py-2 rounded-xl neu-sm text-sm active:scale-[0.98] transition-transform"
      >
        <div className="w-8 h-8 rounded-full neu-fill-blue text-white grid place-items-center shrink-0">
          <Icon className="w-4 h-4" strokeWidth={2.2} />
        </div>
        <span className="font-semibold truncate">{cur[lang] || cur.en}</span>
      </button>
      {open && (
        <div
          className="fixed inset-0 z-[60] bg-black/50 backdrop-blur-md grid place-items-stretch sm:place-items-center p-0 sm:p-4"
          onClick={() => setOpen(false)}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="neu-scope w-full sm:max-w-2xl bg-card neu rounded-none sm:rounded-3xl p-4 sm:p-6 h-full sm:h-auto sm:max-h-[92vh] flex flex-col pt-[calc(env(safe-area-inset-top)+1rem)] sm:pt-6"
          >
            <div className="flex items-center justify-between mb-4 shrink-0">
              <p className="font-display font-extrabold text-lg neu-accent-blue">{lang === "ar" ? "اختر الفئة" : "Pick category"}</p>
              <button data-testid={`${tid}-close`} onClick={() => setOpen(false)} className="p-2 rounded-xl neu-sm">
                <X className="w-5 h-5" />
              </button>
            </div>
            <div className="flex-1 min-h-0 overflow-y-auto">
              <CategoryPicker
                value={value}
                cats={cats}
                onChange={(v) => { onChange(v); setOpen(false); }}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
